import { render, staticRenderFns } from "./SelectCountryArea.vue?vue&type=template&id=5a152b50&"
import script from "./SelectCountryArea.vue?vue&type=script&lang=js&"
export * from "./SelectCountryArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports